import React from 'react';
import FieldLabel from './field-label';
import FieldHelpText from './field-help-text';
import FieldMandatory from './field-mandatory';
import FieldWidth from './field-width';
import ConditionId from './condition-id';

class CheckboxField extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      conditions: props.conditions,
      model: props.model || {},
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return prevState.conditions === nextProps.conditions ?
      null :
      {conditions: nextProps.conditions};
  }

  updateModel(fieldName, value) {
    this.setState(
      prevState => {
        const model = {...prevState.model};
        model[fieldName] = value;
        return {model};
      },
      () => this.props.onChange(this.state.model)
    );
  }

  render() {
    return <div>
      <FieldLabel value={this.state.model.label}
                  onChange={v => this.updateModel('label', v)}/>
      <FieldHelpText value={this.state.model.helpText}
                     onChange={v => this.updateModel('helpText', v)}/>
      <FieldMandatory id={this.props.id}
                      value={this.state.model.mandatory}
                      onChange={v => this.updateModel('mandatory', v)}
                      helpBlock="The form cannot be submitted if the checkbox is not checked."
                      conditionallyDisplayed={!!this.state.model.conditionId}/>
      <div className="form-check">
        <input id={this.props.id + 'CheckedByDefault'}
               name={this.props.id + 'CheckedByDefault'}
               type="checkbox"
               className="form-check-input"
               checked={this.state.model.checkedByDefault == null ? false : this.state.model.checkedByDefault}
               onChange={e => this.updateModel('checkedByDefault', e.target.checked)}/>
        <label className="form-check-label" htmlFor={this.props.id + 'CheckedByDefault'}>
          Checked by default
        </label>
      </div>
      <FieldWidth value={this.state.model.widthInPercent}
                  onChange={v => this.updateModel('widthInPercent', v)}/>
      <ConditionId id={this.props.id}
                   conditions={this.state.conditions}
                   value={this.state.model.conditionId}
                   onChange={v => this.updateModel('conditionId', v)}/>
    </div>;
  }

}

export default CheckboxField;